import { render, staticRenderFns } from "./NomDepartamente.vue?vue&type=template&id=69e70720&scoped=true&"
import script from "./NomDepartamente.vue?vue&type=script&lang=js&"
export * from "./NomDepartamente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e70720",
  null
  
)

export default component.exports
import {QInput,QIcon,QTree,QTooltip,QBtn,QDialog,QCard,QBar,QSpace,QCardSection,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QTree,QTooltip,QBtn,QDialog,QCard,QBar,QSpace,QCardSection,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
